import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Official Golf Divino logo (full, with text).
 * Uses the negativo (white text) variant suitable for dark backgrounds.
 */
export default function Logo({ size = 'md', linkTo = '/' }) {
  const heights = {
    sm: 'h-12 md:h-14',
    md: 'h-16 md:h-20',
    lg: 'h-24 md:h-32',
  };
  const content = (
    <img
      src="/brand/golfdivino-logo-full.png"
      alt="Golf Divino · Business Club"
      className={`${heights[size]} w-auto object-contain transition-transform duration-500 hover:scale-105`}
      draggable={false}
    />
  );
  if (linkTo === null) return content;
  return (
    <Link to={linkTo} aria-label="Golf Divino" className="inline-flex">
      {content}
    </Link>
  );
}
